import React, { useEffect, useMemo } from 'react';
import { useFetch, useUser } from '../../../../shared/hooks';
import { useParams } from 'react-router';
import apiRoutes from '../../../../../config/api/routes';
import { IStudentAssignment, IStudentPaginatedAssignments } from '../../../../../config/api/models/Assignment';
import { useTranslation } from 'react-i18next';
import { UrlParams } from '../../../../shared/types';
import { StudentAssignmentItem } from 'src/modules/student-dashboard/components';

const StudentTasksSideBarContent = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const { trajectoryId } = useParams<UrlParams>();
  const [getAssignmentsResponse, getAssignments] = useFetch<IStudentPaginatedAssignments>(
    apiRoutes.assignments({ userId: user.id, page: 1 })
  );

  useEffect(getAssignments, [getAssignments]);

  const assignmentsByTrajectoryId = useMemo(() => {
    if (!getAssignmentsResponse.success) return [];
    return getAssignmentsResponse.data.data.filter(
      (assignment: IStudentAssignment) => assignment.trajectoryId === trajectoryId
    );
  }, [getAssignmentsResponse, trajectoryId]);

  return !getAssignmentsResponse.success ? null : assignmentsByTrajectoryId.length === 0 ? (
    <>{t('assignments.noAssignmentsForTrajectory')}</>
  ) : (
    <>
      {assignmentsByTrajectoryId.map((assignment: IStudentAssignment) => (
        <StudentAssignmentItem
          key={assignment.id}
          assignment={assignment}
          onFinishAssignment={getAssignments}
          sidebarMode
        />
      ))}
    </>
  );
};

export default StudentTasksSideBarContent;
